import { FileText } from 'lucide-react';
import type { LeadFormField } from '../../../lib/crm/leadForms';
import LeadFormFieldCard from './LeadFormFieldCard';

type Props = {
  fields: LeadFormField[];
  onMoveUp: (fieldId: string) => void;
  onMoveDown: (fieldId: string) => void;
  onOpenSettings: (field: LeadFormField) => void;
  onRemove: (fieldId: string) => void;
  onRequestAddFields?: () => void;
};

const shell = {
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", system-ui, sans-serif',
};

export default function LeadFormCanvas({
  fields,
  onMoveUp,
  onMoveDown,
  onOpenSettings,
  onRemove,
  onRequestAddFields,
}: Props) {
  if (fields.length === 0) {
    return (
      <div
        className="rounded-[12px] border-2 border-dashed border-gray-200 bg-white px-4 py-10 text-center"
        style={shell}
      >
        <div className="w-12 h-12 mx-auto mb-3 rounded-[10px] bg-gray-100 border border-gray-200/60 flex items-center justify-center">
          <FileText className="h-6 w-6 text-gray-400" />
        </div>
        <p className="text-[15px] font-semibold text-gray-900" style={{ letterSpacing: '-0.01em' }}>
          Your form is empty
        </p>
        <p className="text-[13px] text-gray-500 mt-1 mb-4">
          Add fields from the library to start building
        </p>
        {onRequestAddFields ? (
          <button
            type="button"
            onClick={onRequestAddFields}
            className="inline-flex items-center justify-center px-4 py-2.5 text-[14px] font-semibold text-blue-600 bg-blue-50 rounded-[10px] touch-manipulation"
            style={{ minHeight: 44, WebkitTapHighlightColor: 'transparent' }}
          >
            Add fields
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <div className="space-y-3" style={shell}>
      {fields.map((field, index) => (
        <LeadFormFieldCard
          key={field.id}
          field={field}
          index={index}
          fields={fields}
          onMoveUp={onMoveUp}
          onMoveDown={onMoveDown}
          onOpenSettings={onOpenSettings}
          onRemove={onRemove}
        />
      ))}
    </div>
  );
}
